<template>
  <label
    class="base-checkbox"
    :class="{ 'is-active': value, 'is-disabled': disabled }"
  >
    <span class="base-checkbox__inner">
      <span class="base-checkbox__box">
        <svg
          class="base-checkbox__icon"
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
        >
          <path
            d="M8.55545 1.33203L3.66656 6.22092L1.44434 3.9987"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <input
        class="base-checkbox__control"
        type="checkbox"
        :value="value"
        :disabled="disabled"
        @change="handleChange"
      >
      <span class="base-checkbox__label">{{ label }}</span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Выберите вариант',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange() {
      this.$emit('change', !this.value)
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.base-checkbox {
  display: block;
  min-height: 20px;
  font-size: $font-size-body-1;
  user-select: none;
}

.base-checkbox__box {
  width: 14px;
  height: 14px;
  background: $ui-kit-bg-gray-0;
  box-shadow: 0 0 0 2px #424B58;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px 10px 0 0;
}

.base-checkbox__inner {
  display: inline-flex;
  cursor: pointer;
}

.base-checkbox__control {
  position: absolute;
  left: -9999px;
}

.base-checkbox__label {
  font-weight: $weight-medium;
  color: $color-dark-grey;
}

.base-checkbox__icon {
  opacity: 0;
  transition: 200ms ease-in-out;
}

.base-checkbox.is-disabled .base-checkbox__inner {
  opacity: 0.8;
  cursor: not-allowed;
}

.base-checkbox.is-active .base-checkbox__box {
  background-color: #1A5DD0;
  box-shadow: 0 0 0 2px #1A5DD0;
}

.base-checkbox.is-active .base-checkbox__icon {
  opacity: 1;
}

.base-checkbox.is-active .base-checkbox__label {
  color: #1A5DD0;
}
</style>
